export default "__VITE_ASSET__2tp8gvA8__"